import Vue from 'vue';
import Vuetify, {
  VCard,
  VRating,
  VToolbar,
  VLayout
} from 'vuetify/lib';
import nl from 'vuetify/es5/locale/nl';
import en from 'vuetify/es5/locale/en';
import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: {
    VCard,
    VRating,
    VToolbar,
  },
  directives: {
    Ripple,
  },
})

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: "#7F99AC",
        secondary: '#8A80AA',//colors.teal.accent4,
        accent: '#9B5D5D',
        accent1: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#FAFAFA'
      },
      light1: {
        primary: '#ee44aa',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
    lang: {
      locales: { nl, en },
      current: 'nl',
    },
  icons: {
    iconfont: 'md',
  },
});
